/* unplugin-vue-components disabled */import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  value: ""
};
const _hoisted_2 = ["value"];
import { useConfigurationStore } from '@/stores/configurationModule';
import { fontData } from '@/data/fonts';
import useFontLoader from '@/composables/fonts/useFontLoader';
export default {
  __name: 'FontSelect',
  setup(__props) {
    const $eventBus = inject('bus');
    const configurationStore = useConfigurationStore();
    const {
      activeObjects
    } = storeToRefs(configurationStore);
    fontData.sort();
    const {
      loadFont
    } = useFontLoader();

    // -----------------------------------------------------------------------------
    const selected = ref('');
    async function onChangeHandleFont() {
      const activeFont = await loadFont(selected.value);
      $eventBus.$emit('font-changed', activeFont);
    }
    const activeObjectFontFamily = computed(() => {
      const objects = JSON.parse(JSON.stringify(activeObjects.value));
      if (objects.length === 1) {
        return objects[0].fontFamily.split(',')[0];
      }
      return '';
    });
    function setSelected() {
      if (!activeObjectFontFamily.value) {
        return;
      }
      selected.value = activeObjectFontFamily.value;
    }
    onMounted(() => {
      setSelected();
    });
    watch(activeObjects, () => {
      setSelected();
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("select", {
        ref: "fontPick",
        class: "select select-xs w-full max-w-xs",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selected) ? selected.value = $event : null),
        onChange: onChangeHandleFont
      }, [_unref(selected) === '' ? (_openBlock(), _createElementBlock("option", _hoisted_1, " Chose a font... ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fontData), (font, index) => {
        return _openBlock(), _createElementBlock("option", {
          key: index,
          value: font
        }, _toDisplayString(font), 9, _hoisted_2);
      }), 128))], 544)), [[_vModelSelect, _unref(selected)]]);
    };
  }
};